import { useState, useEffect } from "react";
import { ttsService } from "../systems/TTSService";

export function TTSToggle() {
  const [enabled, setEnabled] = useState(ttsService.isEnabled());
  const [loadingState, setLoadingState] = useState(ttsService.getLoadingState());

  useEffect(() => {
    return ttsService.onLoadingChange((state) => setLoadingState(state));
  }, []);

  const toggle = () => {
    const newState = !enabled;
    setEnabled(newState);
    ttsService.setEnabled(newState);
  };

  const isLoading = enabled && loadingState === "loading";

  return (
    <button
      onClick={toggle}
      className={`tts-toggle ${enabled ? "active" : ""} ${isLoading ? "loading" : ""}`}
      title={
        isLoading
          ? "Loading voice engine..."
          : enabled
            ? "Disable voice"
            : "Enable voice"
      }
    >
      {isLoading ? "\u23F3" : enabled ? "\u{1F50A}" : "\u{1F507}"}
    </button>
  );
}
